<div id="countdown" *ngIf="showLoader">
  <div id="countdown-number" #countdownCounterRef></div>
  <svg>
    <circle r="18" cx="20" cy="20"></circle>
  </svg>
</div>
